module.exports = __webpack_public_path__ + "assets/9b959d90a94efb583939da897e79f610.png";